import { types } from '../types/calc';

const initialState = {
  stepOneData: false,
  stepTwoData: false,
  stepThree: false,
  //stepOneData: {bet: 10, max: 3, size: 2},
};

export const calcReducer = (state = initialState, {type, payload}) => {
  switch (type) {

    case types.SET_STEP_ONE_DATA:
      return { ...state, stepOneData: payload };
    case types.CLEAR_STEP_ONE_DATA:
      return { ...state, stepOneData: false };

    case types.SET_STEP_TWO_DATA:
      return { ...state, stepTwoData: payload };
    case types.CLEAR_STEP_TWO_DATA:
      return { ...state, stepTwoData: false };

    case types.SHOW_STEP_THREE:
      return { ...state, stepThree: payload };




    case types.CLEAR_ALL:
      return {
        stepOneData: false,
        stepTwoData: false,
        stepThree: false,
      };

    default:
      return state
  }
};


